import * as React from 'react'
import {Util} from 'yougile-util'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {PersonalChatProxy} from '@extensions/proxies/personal-chat-proxy'
import {SearchResultItemType} from '@extensions/search'
import {UserAvatarV2} from '../../common/user-avatar-v2/user-avatar-v2'
import {ChatInfo, LocationType} from '../chat-info/chat-info'

export const PersonalChatListItem = (
  props: PersonalChatProxy & {
    highlightText?: string
    startFrom?: number
    endAt?: number
    locationType: LocationType
    highlightType?: SearchResultItemType
  }
) => {
  const onClick = () => Tracking.send(TrackingEvent.chatPanelClickUser)
  const bem = Util.bemFrom('personal-chat-list')
  return (
    <div className={bem('item')} onClick={onClick}>
      <div className={bem('avatar')}>
        <UserAvatarV2 {...props} size={20} />
      </div>
      <ChatInfo {...props} type={'personal'} />
    </div>
  )
}
